import { render } from "./CustomerIndexTable.vue?vue&type=template&id=25a065e9"
import script from "./CustomerIndexTable.vue?vue&type=script&lang=js"
export * from "./CustomerIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__